import { APIClient } from '@/services'
import { analytics } from '@/services/analytics/segment'
import { Profile } from './views'

export function useDeleteAccount() {
  const onDeleteAccount = async (id: Profile['id']) => {
    APIClient.Session.logout(true, true)
    APIClient.Session.deleteProfile(id)
    analytics.track('delete_account')
  }

  return {
    onDeleteAccount
  }
}
